export const BATTLE_LAYOUT = {
  opponentBar: { top: 0.0, height: 0.12 },
  opponentPot: { top: 0.12, height: 0.02 },
  idiomStage: { top: 0.14, height: 0.28 },
  wordScroll: { top: 0.42, height: 0.08 },
  selfPot: { top: 0.5, height: 0.16 },
  keyboard: { top: 0.66, height: 0.34 },
} as const;

export type LayoutKey = keyof typeof BATTLE_LAYOUT;
export type Rect = { x: number; y: number; w: number; h: number };

export type Palette = {
  paper: string;
  moon: string;
  ink: string;
  cinnabar: string;
  gamboge: string;
  indigo: string;
  bamboo: string;
  rouge: string;
};

export const PALETTE: Palette = {
  paper: "#fdf9f1",
  moon: "#f7f3eb",
  ink: "#1c1c17",
  cinnabar: "#c83c23",
  gamboge: "#fdbe50",
  indigo: "#5a413c",
  bamboo: "#6E8B3D",
  rouge: "#a5230c",
};

/** 书法纸感排版：衬线承标题与成语，黑体承按钮与提示。 */
export const TYPE = {
  sans: '"PingFang SC","Hiragino Sans GB","Microsoft YaHei","Noto Sans SC",sans-serif',
  serif: '"Songti SC","STSong","SimSun","Noto Serif SC",serif',
} as const;

export const SPACE = {
  margin: 16,
  gutter: 8,
  radius: 12,
} as const;

export const INK = {
  rule: "rgba(28,28,23,0.08)",
  wash: "rgba(90,65,60,0.06)",
  woodFace: "#ffffff",
  woodEdge: "rgba(28,28,23,0.12)",
  woodTray: "#31302b",
  tea: "#7e5700",
  teaWash: "rgba(126,87,0,0.22)",
  silk: "#c83c23",
  card: "#ffffff",
  cardHigh: "#ece8e0",
  gold: "#7e5700",
  inverse: "#31302b",
} as const;

export function resolveLayout(screenW: number, screenH: number): Record<LayoutKey, Rect> {
  const out = {} as Record<LayoutKey, Rect>;
  for (const key of Object.keys(BATTLE_LAYOUT) as LayoutKey[]) {
    const zone = BATTLE_LAYOUT[key];
    out[key] = {
      x: 0,
      y: Math.round(screenH * zone.top),
      w: screenW,
      h: Math.round(screenH * zone.height),
    };
  }
  return out;
}

export function layoutInvariants(): { contiguous: boolean; sum: number; keyboardIsBottomThird: boolean } {
  const keys = Object.keys(BATTLE_LAYOUT) as LayoutKey[];
  let sum = 0;
  let contiguous = true;
  let expected = 0;
  for (const key of keys) {
    const z = BATTLE_LAYOUT[key];
    if (Math.abs(z.top - expected) > 1e-9) contiguous = false;
    expected = z.top + z.height;
    sum += z.height;
  }
  return {
    contiguous,
    sum,
    keyboardIsBottomThird: Math.abs(BATTLE_LAYOUT.keyboard.height - 1 / 3) < 0.01,
  };
}

export function idiomFontSize(stageHeight: number, screenW: number): number {
  const byHeight = stageHeight * 0.5;
  const byWidth = (screenW - 56) / 4;
  return Math.floor(Math.min(byHeight, byWidth, 72));
}

export const IPHONE_SE = { w: 375, h: 667 };

export function seIdiomFontPx(): number {
  const layout = resolveLayout(IPHONE_SE.w, IPHONE_SE.h);
  return idiomFontSize(layout.idiomStage.h, IPHONE_SE.w);
}
